var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#slack-black';
                    var viewUrl = 'svg/icons.svg#view-slack-black';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '40 40 190 190',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };